export default {
    logs:[],
    pagination:{
        total:0,
        current_page:0,
    },
}
